
import { Check, Star, Sparkles } from "lucide-react";
import type { SubscriptionTier } from "@/types/subscription";

export const subscriptionTiers: SubscriptionTier[] = [
  {
    name: "Essentials",
    icon: Check,
    price: "$25",
    description: "Perfect for getting started with AI-powered client communications",
    features: [
      "Basic AI-generated content based on limited user-submitted data",
      "Generalized tone & structure (e.g., greeting + standard message)",
      "Access to 1-2 standard content categories (e.g., birthdays, check-ins)",
    ],
    highlighted: false,
    paypalPlanId: "P-2RX47489C19519606M6WR64I"
  },
  {
    name: "Pro",
    icon: Star,
    price: "$45",
    description: "Enhanced personalization and advanced content features",
    features: [
      "AI-generated content based on deeper user-submitted insights",
      "More refined messaging style, customized tone & voice",
      "Access to all content categories (holidays, milestones, loyalty engagement)",
      'Monthly curated "Surprise & Delight" idea list',
      "Integration with email scheduling tools",
    ],
    highlighted: true,
    paypalPlanId: "P-99221801NC959430WM6WSAUI"
  },
  {
    name: "Elite",
    icon: Sparkles,
    price: "$75",
    description: "Ultra-personalized content and white-glove service",
    features: [
      "Ultra-personalized AI content with deep insights",
      "AI-generated client segmentation",
      "White-glove service: Pre-built engagement sequences",
      "Exclusive VIP Gifting & Experience Ideas",
      "Premium support or consultation access",
    ],
    highlighted: false,
    paypalPlanId: "P-3RR21835CY494835VM6WSBBI"
  }
];

